import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: '#6d6e6f',
    fontSize: '1.5rem',
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  addIcon: {
    alignItems: 'center',
    border: '1px dashed #6d6e6f',
    borderRadius: '50%',
    display: 'flex',
    fill: '#6d6e6f',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'center',
    height: '33px',
    width: '33px',
    marginRight: theme.spacing(1),
  },
  classificationButton: {
    borderRadius: '8px',
    border: '1px solid #d8dde1',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    minWidth: '200px',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#c4c4c4',
      '& $menuButton': {
        opacity: 1,
      },
    },
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  buttonText: {
    color: '#6d6e6f',
    fontWeight: 500,
  },
  classificationName: {
    textTransform: 'capitalize',
    color: '#2c2c2c',
    fontWeight: 500,
  },
  menuButton: {
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(0.5, 1),
      fontSize: '0.875rem',
      color: '#2c2c2c',
    },
  },
  deleteMenuItem: {
    color: theme.palette.error.main,
    fontSize: '0.875rem',
    minHeight: '35px',
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
    },
  },
  dialogTitle: {
    borderBottom: '1px solid #e0e0e0',
    padding: theme.spacing(2),
  },
  cancelButton: {
    color: '#6d6e6f',
    textTransform: 'none',
    fontWeight: 500,
  },
  editButton: {
    color: theme.palette.primary.main,
    opacity: 0.9,
    textTransform: 'none',
    fontWeight: 500,
  },
  deleteButton: {
    opacity: 0.9,
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.error.main,
  },
}));
